export const ICC_SSO_HAV_DEEPLINK_TEMPLATE = 'RAB_SSO_AGE_VERIFICATION_{0}_{1}';
export const ICC_SSO_DSC_SUPPORT_DEEPLINK_TEMPLATE = 'RAB_SSO_SUPPORT_{0}_{1}';
export const ICC_SSO_DSC_REGISTER_DEEPLINK_TEMPLATE = 'RAB_SSO_LIST_DEVICES_{0}_{1}';
export const ICC_SSO_TRADE_IN_DEEPLINK_TEMPLATE = 'RAB_SSO_TRADE_IN_{0}_{1}';
export const ICC_SSO_LOYALTY_CLUB_DASHBOARD_DEEPLINK_TEMPLATE = 'RAB_SSO_LOYALTY_CLUB_DASHBOARD_{0}_{1}';
export const ICC_SSO_LOYALTY_CLUB_HOMEPAGE_DEEPLINK_TEMPLATE = 'RAB_SSO_LOYALTY_CLUB_HOMEPAGE_{0}_{1}';
